import moment from 'moment';

// Format date strings using moment
export const formatDate = (dateString) => {
  if (!dateString) return '-';
  try {
    return moment(dateString).format('DD/MM/YYYY hh:mm A');
  } catch {
    return dateString;
  }
};

// Format numbers with commas
export const formatNumber = (num) => {
  if (num === null || num === undefined) return '-';
  return new Intl.NumberFormat('en-US').format(num);
};

// Format metric values for display
export const formatMetricValue = (value) => {
  if (typeof value === 'number') {
    return formatNumber(value);
  }
  return value || '-';
};

// Parse HTML safely (for report content)
export const sanitizeHTML = (html) => {
  // In production, use DOMPurify library
  // For now, basic sanitization
  return html;
};

// Extract performance metrics
export const getPerformanceMetrics = (metadata) => {
  if (!metadata?.performance) return null;

  const { total_time_ms, query_time_ms, render_time_ms } = metadata.performance;

  return {
    total: `${(total_time_ms / 1000).toFixed(2)}s`,
    query: `${(query_time_ms / 1000).toFixed(2)}s`,
    render: `${(render_time_ms / 1000).toFixed(2)}s`,
  };
};
